import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    featuredList: [],
    isFeaturedLoading: true,
    developerListByRoleSkills: [],
    faqsListByRoleSkills: [],

};

export const homeSlice = createSlice({
    name: "home",
    initialState,
    reducers: {
        setFeaturedList: (state, { payload }) => {
            state.featuredList = payload
        },
        setFeaturedLoading: (state, { payload }) => {
            state.isFeaturedLoading = payload
        },
        setDeveloperListByRoleSkills: (state, { payload }) => {
            state.developerListByRoleSkills = payload
        },
        setFaqsListByRoleSkills: (state, { payload }) => {
            state.faqsListByRoleSkills = payload
        }
    },
});

export const { setFeaturedList, setFeaturedLoading, setDeveloperListByRoleSkills,setFaqsListByRoleSkills } = homeSlice.actions;
export default homeSlice.reducer;